import axios, { AxiosInstance, AxiosError, AxiosResponse } from 'axios';
import { AppRef } from 'common/modules/ReactShared/appInterface/AppRef';

const apiInstance: {
  api: AxiosInstance | null;
  onFulfilledResponse?: (response: AxiosResponse<any>) => AxiosResponse<any>;
  onRejectResponse?: (error: AxiosError) => Promise<any>;
} = { api: null };

interface IInitApiArgs {
  onFulfilledResponse?: (response: AxiosResponse<any>) => AxiosResponse<any>;
  onRejectResponse?: (error: AxiosError) => Promise<any>;
}

function apiInstanceCreator({
  onRejectResponse,
  onFulfilledResponse
}: IInitApiArgs): AxiosInstance {
  const createdApiInstance = axios.create({
    baseURL: AppRef.current?.constants?.API_URI ?? '/',
    headers: { 'X-INFLECT-WITH': 'camel' }
  });

  if (onRejectResponse) {
    createdApiInstance.interceptors.response.use(undefined, onRejectResponse);
  }

  if (onFulfilledResponse) {
    createdApiInstance.interceptors.response.use(onFulfilledResponse);
  }

  return createdApiInstance;
}

export function initApi({
  onRejectResponse,
  onFulfilledResponse
}: IInitApiArgs): AxiosInstance {
  if (apiInstance.api) return apiInstance.api;

  apiInstance.onFulfilledResponse = onFulfilledResponse;
  apiInstance.onRejectResponse = onRejectResponse;
  apiInstance.api = apiInstanceCreator({
    onRejectResponse,
    onFulfilledResponse
  });

  return apiInstance.api;
}

export function initNewApiInstance({
  onRejectResponse,
  onFulfilledResponse
}: IInitApiArgs): AxiosInstance {
  return apiInstanceCreator({
    onFulfilledResponse: onFulfilledResponse ?? apiInstance.onFulfilledResponse,
    onRejectResponse: onRejectResponse ?? apiInstance.onRejectResponse
  });
}

export function getApi(): AxiosInstance {
  return initApi({});
}

export function setApiClientHeader(headerName: string, value: string): void {
  getApi().defaults.headers.common[headerName] = value;
}

export const api = apiInstance;
